var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",style:({
		transform: ("rotate(" + _vm.rotate + "deg)"),
	})},[(_vm.type === 'fontClass')?_c('i',{class:['iconfont', _vm.name],style:({
			fontSize: _vm.comSize,
			color: _vm.color,
		})}):_c('svg',{staticClass:"icon",style:({ width: _vm.comSize, height: _vm.comSize, verticalAlign: _vm.verticalAlign }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":("#" + _vm.name)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-353713b7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/icon/Icon.vue
// module id = null
// module chunks = 